module.exports = __webpack_public_path__ + "img/server-dash.jpg_w545.74ac4db6.jpg";